
import Action from '../Action';
// import './styles/createAgency.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import SelectorIcons from '../SelectorIcons';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
import MultiSelector from '../MultiSelector';
const ModalCreateUser=({handleShowPopup,getRoles,userId,userData,dataRoles,user,languaje,mode,devices,server,setRegisterIsValid,dataMantto,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({name:(editActive)?dataMantto.name:"",mail:(editActive)?dataMantto.mail:"",roles:(editActive)?dataMantto.roles:"1",group_ids:(editActive)?dataMantto.groups.map(item => item.id):[],authorizer:0})
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)
    // console.log(lang[languaje]['nombre'])
    const metricData=useFetch('cassia/user_groups','','','GET',server)
    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)

    const addRoles=(e)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['roles']:''+e
            }
            
        })
    }
    const validateEmail = (email) => {
        // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        // const emailRegex = /^[a-zA-Z0-9._-]+@seguritech\.com$/;
        // const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.com$/;
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let result = emailRegex.test(email);
        return result;
    };
    const validateName = (name) => {
      const nameRegex = /^[A-Za-zÀ-ÿ\s]{8,}$/;
      let result = nameRegex.test(name);
      return result;
    };
    const handleChange=(e)=>{
        const {name,value}=e.target
        // setRol(parseInt(e.target.value, 10))

        setManttoData((prevState)=>{
            return {
                ...prevState,
                [name]:value
            }
            
        })

        if(e.target.name=="mail"){
            setCorreoIsValid(validateEmail(value))
        }else if(e.target.name=="name"){
            setNombreIsValid(validateName(value))
        }
    }
    const [correoIsValid, setCorreoIsValid] = useState(true);
    const [nombreIsValid, setNombreIsValid] = useState(true);

    useEffect(()=>{
     
      if(ManttoData.name==="" || ManttoData.mail==="" || nombreIsValid===false || correoIsValid===false ){
          setDisabled(true)
      }else{
          setDisabled(false)
      }
      
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            url_add=userId
        }

        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/users/'+url_add, {
             method: method,  
             headers: {
               'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
             // console.log(data1);
             // Regresar()
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             getRoles()
             closCreateCisModal()
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              // setUserData({name:"",mail:"",roles:"1"})
              setManttoData({name:"",mail:"",roles:"1",group_ids:[],authorizer:0})
      
      setLoading(false)
            // Manejo de errores
            setError(error)
            setRegisterIsValid(true)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }
    useEffect(()=>{
        if(editActive){
            buscar_host(dataMantto.ip)
        }
    },[])
    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        addRoles(option.value)
        // setManttoRelation(option.value)
    }
    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
      };
    const [resultList,setResultList]=useState([])
    const handleSearchHost=(e)=>{
      
      const term = e.target.value;
      const {name,value}=e.target
      if(name=="ip"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['ip']:value
              }
              
          })
      }
      // console.log(value)
      // setInputIP(value)
      setIpValid(validateIp(value))
      
      const filteredResults = devices.data.hosts.filter((item) => {
          
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });
     
        setResultList(filteredResults)
    }

    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const [iconsSelected,setIconSelected]=useState(0)

    const [colorHex, setColor] = useState('#ff0000');

    const handleColorChange = (event) => {
      // setColor(event.target.value);
      setManttoData((prevState)=>{
          return {
              ...prevState,
              ['color']:event.target.value
          }
          
      })
    };
    const handleIconChange=(id,url)=>{
      setIconSelected(id)
      setManttoData((prevState)=>{
          return {
              ...prevState,
              ['img']:url
          }
          
      })
    }
    const reqField=()=>{
      return(
        <p className='reqField-gs'>
          *
        </p>
      )
    }
    const changeMultiOption=(option,index,titulo)=>{
      let attr=""
      if(titulo=="Grupos"){
        attr="groupids"
      }
      
          setManttoData((prevState)=>{
            return {
                ...prevState,
              ['group_ids']:option.map(item => item.value)
            }
            
        })
     
    }
    const {name,mail,roles,group_ids}=ManttoData;
    return(
        
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['usuario'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs'>
                                {1==1?
                                // nivelForm===1?
                                    <>
                                    <div className="form-GS-box"> 
                                    
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        <input required name="name"  type="text" value={name}
                                    onChange={handleChange} />
                                        <label className='label-GS'> {capitalizeFirstLetter(lang[languaje]['nombre'])}{(name=="")?reqField():''}</label>
                                        {
                                            (name==="" || nombreIsValid)?'':<span className='form-msg-error-admin' style={{bottom: '10%'}}> {capitalizeFirstLetter(lang[languaje]['nombreNoValido'])}</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        <input required name="mail"  type="text" value={mail}
                                    onChange={handleChange} />
                                        <label className='label-GS'> {capitalizeFirstLetter(lang[languaje]['correo'])}{(mail=="")?reqField():''}</label>
                                        {
                                            (mail==="" || correoIsValid)?'':<span className='form-msg-error-admin' style={{bottom: '10%'}}> {capitalizeFirstLetter(lang[languaje]['correoNoValido'])}.</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'20%'}}>
                                        {/* <div className='contListIconsAgencys' style={{border:'unset'}}> */}
                                        <div className="user-box-admin roles"style={{height:'50%'}}>
                                   {/* <div className="container-tabs-roles"> 
                                                <div className="tabs-roles">
                                                    
                                                    <div className='box-options'>
                                                    { (dataRoles.loading)?<LoadSimple></LoadSimple>:
                                                    
                                                dataRoles.data.data.map((element,index)=>(
                                                    <>
                                                    <div className='contOptionRol'>
                                                        <input type="radio" id={"radio-"+index} name="tabs-roles" defaultChecked={(element.rol_id == roles)}   />
                                                        <label className="option-role" htmlFor={"radio-"+index} onClick={()=>addRoles(element.rol_id)}>{element.name}</label>
                                                        </div>
                                                    </>
                                                ))}
                                                        
                                                    </div>
                                                </div>
                                            </div> */}
                                            {
                                            
                                           
                                            (dataRoles.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={roles} origen={'Admin'} data={dataRoles.data.data}   loading={dataRoles.loading}  titulo='roles' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                   </div>
                                  
                                   
                                            
                                        
                                        <label className='label-GS'>{'Rol'}</label> 
                                       
                                    </div>
                                    <div className="user-box-GS "  style={{height:'20%'}}>
                                       
                                       
                                          
                                          {
                                            (metricData.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <MultiSelector placeholder={capitalizeFirstLetter(lang[languaje]['seleccionar'])+' '+lang[languaje]['gruposUsuarios']} opGeneral={false} txtOpGen={''}  opt_de={group_ids} origen={'Admin'} data={metricData.data.data}   loading={metricData.loading}  titulo={'Estados'} selectFunction={changeMultiOption} index={0}></MultiSelector>
                                          }
                                          
                                            
                                        
                                        <label className='label-GS' >{capitalizeFirstLetter(lang[languaje]['gruposUsuarios'])}</label>   
                                    </div>
                                    <div className="user-box-admin" style={{height:'20%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                              <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                              <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>{'Usuario '+(editActive? 'editado':'registrado' )+' correctamente'}</span>:''
                                    }
                                        
                                    </div>
                                </div>
                                    </> 
                                    :''
                                 
                            }
                            </div>
                </div>
        </div>
    )
}

export default ModalCreateUser